import { render, staticRenderFns } from "./PageThanks.vue?vue&type=template&id=8316b8fa&scoped=true&lang=pug"
import script from "./PageThanks.vue?vue&type=script&lang=ts"
export * from "./PageThanks.vue?vue&type=script&lang=ts"
import style0 from "./PageThanks.vue?vue&type=style&index=0&id=8316b8fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8316b8fa",
  null
  
)

export default component.exports